import { Table, Input, ConfigProvider } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_ENDPOINTS } from '../../assets/api/endpoints';
import './Countries.scss';
import Header from '../../components/Header/Header';
import { SearchOutlined } from '@ant-design/icons';
import { getCountryAndPaymMethodColumn } from '../../helpers/countryAndPaymMethodColumn';
import axios from 'axios';
import { CountryAndPaymentMethodFilters } from '../../models/CountryAndPaymentMethod';
import { themeConfig } from '../WalletTransactions/config';
import { useConfigurationContext } from '../../store/configurationContext';
import { StyledPagination } from '../../components/table.style';

const Countries = () => {
	const { t } = useTranslation();
	const [countriesAndPaymLoading, setCountriesAndPaymLoading] = useState(false);
	const [countryAndPayms, setCountryAndPayms] = useState([]);
	const [sortBy, setSortBy] = useState<string>('name-asc');
	const [pageSize, setPageSize] = useState(10);
	const [page, setPage] = useState(0);
	const [totalElements, setTotalElements] = useState(0);
	const [searchTerm, setSearchTerm] = useState('');
	const [searchValue, setSearchValue] = useState('');
	const { configurationState } = useConfigurationContext();
	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';
	useEffect(() => {
		setCountriesAndPaymLoading(true);
		axios
			.get(`${API_ENDPOINTS.countries}`)
			.then((res) => {
				const sortedData = res.data
					.sort((a: any, b: any) => {
						switch (sortBy) {
							case CountryAndPaymentMethodFilters.nameDesc:
								return a.countryName.localeCompare(b.countryName);
							case CountryAndPaymentMethodFilters.nameAsc:
								return b.countryName.localeCompare(a.countryName);
							case CountryAndPaymentMethodFilters.countryCodeAsc:
								return a.countryCode.localeCompare(b.countryCode);
							case CountryAndPaymentMethodFilters.countryCodeDesc:
								return b.countryCode.localeCompare(a.countryCode);
							case CountryAndPaymentMethodFilters.currencyCodeAsc:
								return a.currencyCode.localeCompare(b.currencyCode);
							case CountryAndPaymentMethodFilters.currencyCodeDesc:
								return b.currencyCode.localeCompare(a.currencyCode);
							case CountryAndPaymentMethodFilters.maxProfitAcs:
								return a.maxProfitRatio - b.maxProfitRatio;
							case CountryAndPaymentMethodFilters.maxProfitDesc:
								return b.maxProfitRatio - a.maxProfitRatio;
							case CountryAndPaymentMethodFilters.isPublicAsc:
								return a.isPublic - b.isPublic;
							case CountryAndPaymentMethodFilters.isPublicDesc:
								return b.isPublic - a.isPublic;
							default:
								return 0;
						}
					})
					.filter((obj: any) =>
						Object.values(obj).some(
							(val: any) => val?.toString().toLocaleLowerCase().includes(searchValue.toString().toLocaleLowerCase()),
						),
					);
				setCountryAndPayms(sortedData);
				setTotalElements(sortedData.length);
			})
			.catch((err) => console.error(err))
			.finally(() => setCountriesAndPaymLoading(false));
	}, [sortBy, searchValue]);

	useEffect(() => {
		const delaySearch = setTimeout(() => {
			setSearchValue(searchTerm);
		}, 1000);
		return () => clearTimeout(delaySearch);
	}, [searchTerm]);

	useEffect(() => {
		setPage(0);
		setPageSize(10);
	}, [searchValue]);

	return (
		<div className='countries-and-paym-container'>
			<Header title={t<string>('countriesPaymentMethods')} description={t<string>('CountryAndPaymentMethods')} />
			<div className='min-h-[84vh] mx-auto px-5 py-5 bg-white '>
				<div className='flex justify-end items-center my-2'>
					<Input
						className='border-none h-10 bg-[#F5F5F5] search-input w-[200px] xss:my-4 lg:my-0'
						placeholder={t<string>('searchInCountries')}
						value={searchTerm}
						onChange={(e) => {
							setSearchTerm(e.target.value);
						}}
						size='large'
						prefix={<SearchOutlined className='mr-2' />}
					/>
				</div>
				<ConfigProvider theme={themeConfig}>
					<StyledPagination bgColor={themeColor} color={secondary_color}>
						<Table
							columns={getCountryAndPaymMethodColumn(t, sortBy, setSortBy)}
							dataSource={countryAndPayms}
							pagination={{
								pageSize,
								total: totalElements,
								onChange: (pageIndex) => setPage(pageIndex - 1),
								current: page + 1,
							}}
							loading={countriesAndPaymLoading}
							tableLayout='auto'
						/>
					</StyledPagination>
				</ConfigProvider>
			</div>
		</div>
	);
};

export default Countries;
